import Vue from 'vue'
import Router from 'vue-router'
import { _uuid } from '@/utils/funcs'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
import componentsRouter from './modules/components'
import chartsRouter from './modules/charts'
import tableRouter from './modules/table'
import nestedRouter from './modules/nested'

export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true,
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true,
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true,
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: 'HomeIndex',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: '儀錶板',
        meta: { title: '儀錶板', icon: 'dashboard', affix: true },
      },
    ],
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'Profile', icon: 'el-icon-sunny' },
      },
    ],
  },
  {
    path: '/itaProfile',
    component: Layout,
    redirect: '/itaProfile/index',
    hidden: true,
    meta: {
      keepAlive: true,
      title: '個人資料',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/ita/auth/profile/index'),
        name: 'ItaProfile',
        meta: { title: '個人資料', icon: 'el-icon-sunny' },
      },
    ],
  },
  {
    path: '/educationResources',
    component: Layout,
    redirect: '/educationResources/index',
    hidden: true,
    meta: {
      keepAlive: true,
      title: '教學資源',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/ita/agency/educationResources/index'),
        name: 'EducationResources',
        meta: { title: '教學資源', icon: 'el-icon-sunny' },
      },
    ],
  },
  {
    path: '/faultBack',
    component: Layout,
    redirect: '/faultBack/index',
    hidden: true,
    meta: {
      keepAlive: true,
      title: '故障與回饋',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/ita/appManage/faultBack/index'),
        name: 'FaultBack',
        meta: { title: '故障與回饋', icon: 'el-icon-sunny' },
      },
    ],
  },
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // {
  //   path: '/nested',
  //   component: Layout,
  //   redirect: '/nested/menu1/menu1-1',
  //   name: 'Nested',
  //   meta: {  keepAlive: true ,
  //     title: 'Nested Routes',
  //     icon: 'nested'
  //   },
  //   children: [
  //     {
  //       path: 'menu1',
  //       component: () => import('@/views/nested/menu1/index'), // Parent router-view
  //       name: 'Menu1',
  //       meta: {  title: 'Menu 1' },
  //       redirect: '/nested/menu1/menu1-1',
  //       children: [
  //         {
  //           path: 'menu1-1',
  //           component: () => import('@/views/nested/menu1/menu1-1'),
  //           name: 'Menu1-1',
  //           meta: {  title: 'Menu 1-1' }
  //         },
  //         {
  //           path: 'menu1-2',
  //           component: () => import('@/views/nested/menu1/menu1-2'),
  //           name: 'Menu1-2',
  //           redirect: '/nested/menu1/menu1-2/menu1-2-1',
  //           meta: {  title: 'Menu 1-2' },
  //           children: [
  //             {
  //               path: 'menu1-2-1',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
  //               name: 'Menu1-2-1',
  //               meta: {  title: 'Menu 1-2-1' }
  //             },
  //             {
  //               path: 'menu1-2-2',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-2'),
  //               name: 'Menu1-2-2',
  //               meta: {  title: 'Menu 1-2-2' }
  //             }
  //           ]
  //         },
  //         {
  //           path: 'menu1-3',
  //           component: () => import('@/views/nested/menu1/menu1-3'),
  //           name: 'Menu1-3',
  //           meta: {  title: 'Menu 1-3' }
  //         }
  //       ]
  //     },
  //     {
  //       path: 'menu2',
  //       name: 'Menu2',
  //       component: () => import('@/views/nested/menu2/index'),
  //       meta: {  title: 'Menu 2' }
  //     }
  //   ]
  // },

  {
    path: '/chat',
    component: Layout,
    redirect: '/chat',
    alwaysShow: false, // will always show the root menu
    name: 'Chat',
    meta: {
      keepAlive: true,
      title: '即時訊息',
      icon: 'nested',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/ita/chat/index'),
        name: 'ChatIndex',
        meta: { title: '即時訊息', icon: 'el-icon-chat-line-round' },
      },
    ],
  },
  {
    path: '/news',
    component: Layout,
    redirect: '/news',
    alwaysShow: false,
    name: 'News',
    meta: {
      keepAlive: true,
      title: '最新消息❗',
      icon: 'nested',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/ita/news/index'),
        name: 'NewsIndex',
        meta: { title: '最新消息❗', icon: 'el-icon-bell' },
      },
    ],
  },
  {
    path: '/notice',
    component: Layout,
    redirect: '/notice',
    alwaysShow: false, // will always show the root menu
    name: 'Notice',
    meta: {
      keepAlive: true,
      title: '通知管理',
      icon: 'nested',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/ita/notice/index'),
        name: 'NoticeIndex',
        meta: { title: '通知管理', icon: 'el-icon-bell' },
      },
    ],
  },
  {
    path: '/agency/agencyInfo/index',
    component: Layout,
    name: 'AgencyManage',
    alwaysShow: true,
    meta: {
      keepAlive: true,
      title: '旅行社管理',
      icon: 'el-icon-connection',
    },
    children: [
      {
        path: '/agency/agencyInfo/index',
        component: () => import('@/views/ita/agency/agencyInfo/index'),
        name: 'AgencyInfo',
        meta: { title: '基本資料', icon: 'el-icon-school' },
      },
      {
        path: '/agency/agencyTravelManage/index',
        component: () => import('@/views/ita/travel/index'),
        name: 'agencyTravelList',
        meta: { title: '團體管理', icon: 'el-icon-first-aid-kit' },
      },
      {
        path: '/agency/agencyTravelersManage/index',
        component: () => import('@/views/ita/traveler/index'),
        name: 'AgencyTravelersList',
        meta: { title: '旅客管理', icon: 'el-icon-user' },
      },
      {
        path: '/agency/tourLeader/index',
        component: () => import('@/views/ita/tourLeader/index'),
        name: 'AgencyTourLeader',
        meta: { title: '領隊管理', icon: 'el-icon-place' },
      },
      {
        path: '/appManage/publicAlbum/index',
        component: () => import('@/views/ita/appManage/publicAlbum/index'),
        name: 'PublicAlbum',
        meta: { title: '共享相簿', icon: 'el-icon-picture-outline' },
      },
      {
        path: '/agency/agencyOpinionSurvey/index',
        component: () => import('@/views/ita/agency/agencyOpinionSurvey/index'),
        name: 'AgencyOpinionSurvey',
        meta: { title: '意見調查表', icon: 'el-icon-edit-outline' },
      },

      {
        path: '/agency/agencyCoupon/index',
        component: () => import('@/views/ita/appManage/coupon/index'),
        name: 'AgencyCoupon',
        redirect: 'noRedirect',
        meta: { title: '票券管理', icon: 'el-icon-s-ticket' },
        children: [
          {
            path: '/agency/agencyCoupon/saleCoupon/index',
            component: () => import('@/views/ita/appManage/coupon/saleCoupon'),
            name: 'AgencySaleCoupon',
            meta: { title: '優惠活動管理', icon: 'el-icon-postcard' },
          },
          {
            path: '/agency/agencyCoupon/couponCategory/index',
            component: () => import('@/views/ita/appManage/coupon/couponCategory'),
            name: 'AgencyCouponCategory',
            meta: { title: '分類管理', icon: 'el-icon-s-flag' },
          },
        ],
      },
      {
        path: '/agency/commonForms/index',
        component: () => import('@/views/ita/agency/commonForms/index'),
        name: 'CommonForms',
        meta: {
          keepAlive: true,
          title: '常用表單管理',
          icon: 'el-icon-notebook-2',
        },
      },

      // {
      //   path: '/agency/agencyResultForms/index',
      //   component: () => import('@/views/ita/agency/agencyResultForms/index'),
      //   name: 'AgencyResultForms',
      //   meta: {  title: '領隊回傳表單', icon: 'el-icon-sunny' }
      // },
      {
        path: '/agency/agencyRecordRequest/index',
        component: () => import('@/views/ita/agency/agencyRecordRequest/index'),
        name: 'AgencyRecordRequest',
        meta: { title: '客訴與紀錄資訊', icon: 'el-icon-circle-close' },
      },

      {
        path: '/agency/accountsPayableManagement/index',
        component: () => import('@/views/ita/agency/accountsPayableManagement/index'),
        name: 'AccountsPayableManagement',
        meta: { title: '應付帳款管理', icon: 'el-icon-money' },
      },
      {
        path: '/agency/promotionalPlansManagement/index',
        component: () => import('@/views/ita/agency/promotionalPlansManagement/index'),
        name: 'PromotionalPlansManagement',
        meta: { title: '活動管理', icon: 'el-icon-money' },
      },
      {
        path: '/agency/agencyPayment/index',
        // component: () => import('@/views/ita/agency/agencyPayment/index'),
        component: () => import('@/views/error-page/999'),
        name: 'AgencyPayment',
        meta: { title: '請款及發票', icon: 'el-icon-sunny' },
      },
      {
        path: '/agency/accountsReceivableManagement/index',
        component: () => import('@/views/ita/agency/accountsReceivableManagement/index'),
        name: 'AccountsReceivableManagement',
        meta: { title: '應收帳款管理', icon: 'el-icon-money' },
      },
      {
        path: '/agency/agencyLeaderHunter/index',
        // component: () => import('@/views/ita/agency/agencyLeaderHunter/index'),
        component: () => import('@/views/error-page/999'),
        name: 'AgencyLeaderHunter',
        meta: { title: '尋找領隊', icon: 'el-icon-sunny' },
      },
      {
        path: '/agency/outSideContract/index',
        component: () => import('@/views/ita/agency/outSideContract/index'),
        name: 'OutSideContract',
        meta: { title: '線上合約', icon: 'el-icon-sunny' },
      },
    ],
  },
  {
    path: '/appManage',
    component: Layout,
    redirect: 'noRedirect',
    name: 'AppManage',
    alwaysShow: true,
    meta: {
      keepAlive: true,
      title: '團體App管理',
      icon: 'el-icon-mobile-phone',
    },
    children: [
      {
        path: '/appManage/travel/index',
        component: () => import('@/views/ita/travel/index'),
        name: 'Travel',
        meta: { title: '旅遊團管理', icon: 'el-icon-first-aid-kit' },
      },
      {
        path: '/appManage/coupon/index',
        component: () => import('@/views/ita/appManage/coupon/index'),
        name: 'Coupon',
        redirect: 'noRedirect',
        meta: { title: '票券管理', icon: 'el-icon-s-ticket' },
        children: [
          {
            path: '/appManage/coupon/saleCoupon/index',
            component: () => import('@/views/ita/appManage/coupon/saleCoupon'),
            name: 'SaleCoupon',
            meta: { title: '優惠券管理', icon: 'el-icon-postcard' },
          },
          // {
          //   path: "/appManage/coupon/couponTag/index",
          //   component: () => import("@/views/ita/appManage/coupon/couponTag"),
          //   name: "CouponTag",
          //   meta: {  title: "標籤管理", icon: "el-icon-price-tag" },
          // },
          {
            path: '/appManage/coupon/couponCategory/index',
            component: () => import('@/views/ita/appManage/coupon/couponCategory'),
            name: 'CouponCategory',
            meta: { title: '分類管理', icon: 'el-icon-folder' },
          },
        ],
      },
      {
        path: '/appManage/agency/index',
        component: () => import('@/views/ita/appManage/agency/index'),
        name: 'AppManageAgency',
        meta: { title: '旅行社管理', icon: 'el-icon-edit' },
      },
      {
        path: '/appManage/agencyRecordReview/index',
        component: () => import('@/views/ita/appManage/agencyRecordReview/index'),
        name: 'AgencyRecordReview',
        meta: { title: '紀錄資訊審核', icon: 'el-icon-circle-check' },
      },
      {
        path: '/appManage/networkCard/index',
        component: () => import('@/views/ita/appManage/networkCard/index'),
        name: 'NetworkCard',
        meta: { title: '網卡管理', icon: 'el-icon-bank-card' },
      },
      {
        path: '/appManage/viewPoint/index',
        component: () => import('@/views/ita/appManage/viewPoint/index'),
        name: 'ViewPoint',
        meta: { title: '景點管理', icon: 'el-icon-location-information' },
      },
      {
        path: '/appManage/tourLeader/index',
        component: () => import('@/views/ita/tourLeader/index'),
        name: 'TourLeader',
        meta: { title: '領隊管理', icon: 'el-icon-place' },
      },
      {
        path: '/appManage/knowledge/index',
        component: () => import('@/views/ita/appManage/knowledge/index'),
        name: 'Knowledge',
        meta: { title: '知識管理', icon: 'el-icon-guide' },
      },
      {
        path: '/appManage/settings/index',
        component: () => import('@/views/ita/appManage/settings/index'),
        name: 'AppManageSettings',
        meta: { title: '其他設定', icon: 'el-icon-sunny' },
      },
      {
        path: '/appManage/appPosition/index',
        component: () => import('@/views/ita/appManage/appPosition/index'),
        name: 'AppPosition',
        meta: { title: '團體經緯度', icon: 'el-icon-money' },
      },
      {
        path: '/appManage/socketInfo/index',
        component: () => import('@/views/ita/appManage/socketInfo/index'),
        name: 'SocketInfo',
        meta: { title: '導覽Socket狀態', icon: 'el-icon-money' },
      },
      {
        path: '/appManage/goGreen/index',
        component: () => import('@/views/ita/appManage/goGreen/index'),
        name: 'GoGreen',
        meta: { title: '智慧減碳補助', icon: 'el-icon-document' },
      },
      {
        path: '/appManage/newsSetting/index',
        component: () => import('@/views/ita/appManage/newsSetting/index'),
        name: 'NewsSetting',
        meta: { title: '最新消息設定❗', icon: 'el-icon-sunny' },
      },
    ],
  },
  {
    path: '/toursCombine',
    component: Layout,
    name: 'ToursCombineManage',
    alwaysShow: true,
    meta: {
      keepAlive: true,
      title: 'TC網頁管理',
      icon: 'el-icon-search',
    },
    children: [
      {
        path: '/toursCombine/member/index',
        component: () => import('@/views/ita/toursCombine/member/index'),
        name: 'TcMemberManagement',
        redirect: 'noRedirect',
        meta: { title: '會員管理', icon: 'el-icon-user' },
        children: [
          {
            path: '/toursCombine/member/tcMember/index',
            component: () => import('@/views/ita/toursCombine/member/tcMember/index'),
            name: 'TcMember',
            meta: { title: '平台會員', icon: 'el-icon-mouse' },
          },
          {
            path: '/toursCombine/member/tcMember/leader',
            component: () => import('@/views/ita/toursCombine/member/tcMemberLeader/index'),
            name: 'TcMemberLeader',
            meta: { title: '導遊領隊', icon: 'el-icon-s-flag' },
          },
          {
            path: '/toursCombine/member/manufacturers/index',
            component: () => import('@/views/ita/toursCombine/member/manufacturers/index'),
            name: 'TcMemberManufacturers',
            meta: { title: '合作廠商', icon: 'el-icon-s-custom' },
          },
          {
            path: '/toursCombine/member/medias/index',
            component: () => import('@/views/ita/toursCombine/member/medias/index'),
            name: 'TcMemberMedias',
            meta: { title: '合作媒體', icon: 'el-icon-camera' },
          },
        ],
      },
      {
        path: '/toursCombine/tcSetting/index',
        component: () => import('@/views/ita/toursCombine/tcSetting/index'),
        name: 'SettingIndex',
        meta: { title: '首頁管理', icon: 'el-icon-s-home' },
      },
      {
        path: '/toursCombine/tcSetting/country',
        component: () => import('@/views/ita/toursCombine/tcSetting/country'),
        name: 'SettingCountry',
        meta: { title: '國家管理', icon: 'el-icon-map-location' },
      },
      {
        path: '/toursCombine/tcSetting/type',
        component: () => import('@/views/ita/toursCombine/tcSetting/type'),
        name: 'SettingType',
        meta: { title: '項目及分類', icon: 'el-icon-receiving' },
      },
      {
        path: '/toursCombine/tcSetting/hashtag',
        component: () => import('@/views/ita/toursCombine/tcSetting/hashTag'),
        name: 'SettingHashTag',
        meta: { title: 'HashTag管理', icon: 'el-icon-star-off' },
      },
      {
        path: '/toursCombine/tcSetting/description',
        component: () => import('@/views/ita/toursCombine/tcSetting/description'),
        name: 'SettingDescription',
        meta: { title: '說明設定', icon: 'el-icon-collection' },
      },
      {
        path: '/toursCombine/articleItem/index',
        component: () => import('@/views/ita/toursCombine/articleItem/index'),
        name: 'TcArticleItem',
        redirect: 'noRedirect',
        meta: { title: '文章管理', icon: 'el-icon-document' },
        children: [
          {
            path: '/toursCombine/articleItem/all/index',
            component: () => import('@/views/ita/toursCombine/articleItem/all/index'),
            name: 'TcArticleItemArticle',
            meta: { title: '全部', icon: 'el-icon-tickets' },
          },
          {
            path: '/toursCombine/articleItem/travelNews/index',
            component: () => import('@/views/ita/toursCombine/articleItem/travelNews/index'),
            name: 'TcArticleItemTravelerNews',
            meta: { title: '旅遊新聞', icon: 'el-icon-news' },
          },
          {
            path: '/toursCombine/articleItem/travelBlog/index',
            component: () => import('@/views/ita/toursCombine/articleItem/travelBlog/index'),
            name: 'TcArticleItemTravelerBlog',
            meta: { title: '旅遊專欄', icon: 'el-icon-notebook-1' },
          },
          {
            path: '/toursCombine/articleItem/travelVideo/index',
            component: () => import('@/views/ita/toursCombine/articleItem/travelVideo/index'),
            name: 'TcArticleItemTravelerVideo',
            meta: { title: '旅遊影片', icon: 'el-icon-video-camera' },
          },
          {
            path: '/toursCombine/articleItem/travelKnowledge/index',
            component: () => import('@/views/ita/toursCombine/articleItem/travelKnowledge/index'),
            name: 'TcArticleItemTravelKnowledge',
            meta: { title: '旅遊知識', icon: 'el-icon-s-opportunity' },
          },
          {
            path: '/toursCombine/articleItem/discussionArea/index',
            component: () => import('@/views/ita/toursCombine/articleItem/discussionArea/index'),
            name: 'TcArticleItemDiscussionArea',
            meta: { title: '綜合討論區', icon: 'el-icon-chat-square' },
          },
        ],
      },
      {
        path: '/toursCombine/articleComment/index',
        component: () => import('@/views/ita/toursCombine/articleComment/index'),
        name: 'ArticleComment',
        meta: { title: '評論管理', icon: 'el-icon-chat-line-square' },
      },
      {
        path: '/toursCombine/application/index',
        component: () => import('@/views/ita/toursCombine/application/index'),
        name: 'Application',
        redirect: 'noRedirect',
        meta: { title: '駐站申請', icon: 'el-icon-document-add' },
        children: [
          {
            path: '/toursCombine/bloggerApplication/index',
            component: () => import('@/views/ita/toursCombine/application/bloggerApplication'),
            name: 'BloggerApplication',
            meta: { title: '部落客', icon: 'el-icon-sunny' },
          },
          {
            path: '/toursCombine/leaderApplication/index',
            component: () => import('@/views/ita/toursCombine/application/leaderApplication'),
            name: 'LeaderApplication',
            meta: { title: '導遊領隊', icon: 'el-icon-sunny' },
          },
        ],
      },
      {
        path: '/toursCombine/adultTextBlocking/index',
        component: () => import('@/views/ita/toursCombine/adultTextBlocking/index'),
        name: 'AdultTextBlocking',
        meta: { title: '文章限制', icon: 'el-icon-chat-line-square' },
      },

      // {
      //   path: '/toursCombine/travelerLive/index',
      //   // component: () => import('@/views/ita/toursCombine/travelerLive/index'),
      //   component: () => import('@/views/error-page/999'),
      //   name: 'TravelerLive',
      //   meta: {  title: '旅人直播', icon: 'el-icon-sunny' }
      // },
      // {
      //   path: '/toursCombine/OnlineLecture/index',
      //   // component: () => import('@/views/ita/toursCombine/onlineLecture/index'),
      //   component: () => import('@/views/error-page/999'),
      //   name: 'OnlineLecture',
      //   meta: {  title: '線上講座', icon: 'el-icon-sunny' }
      // }
    ],
  },
  {
    path: '/ita',
    component: Layout,
    name: 'ITA',
    alwaysShow: true,
    meta: {
      keepAlive: true,
      title: '官網維護',
      icon: 'el-icon-warning-outline',
    },
    children: [
      {
        path: '/itaSetting/news',
        component: () => import('@/views/ita/itaSetting/newsArticle'),
        name: 'SettingITANews',
        meta: { title: '最新消息', icon: 'el-icon-bell' },
      },
      {
        path: '/itaSetting/cooperative-manufacturers',
        component: () => import('@/views/ita/itaSetting/manufacturers'),
        name: 'SettingITAManufacturers',
        meta: { title: '合作廠商', icon: 'el-icon-s-custom' },
      },
    ],
  },
  {
    path: 'ita-service',
    component: Layout,
    name: 'ItaService',
    alwaysShow: false,
    meta: {
      keepAlive: true,
      title: '客服系統',
      icon: 'el-icon-service',
    },
    children: [
      {
        name: 'ItaServiceLink',
        meta: { title: '客服系統', icon: 'link' },
        path: '/service',
      },
    ],
  },
  {
    path: '/advertisement',
    component: Layout,
    name: 'AdvertisementMange',
    alwaysShow: true,
    meta: {
      keepAlive: true,
      title: '廣告管理',
      icon: 'el-icon-coin',
    },
    children: [
      {
        path: '/advertisement/index',
        component: () => import('@/views/error-page/999'),
        name: 'AdvertisementIndex',
        meta: { title: '數據總覽', icon: 'el-icon-data-analysis' },
      },
      {
        path: '/advertisement/customerCompany',
        component: () => import('@/views/ita/advertisement/customerCompany'),
        name: 'AdvertisementCustomerCompany',
        meta: { title: '商家管理', icon: 'el-icon-suitcase' },
      },
      {
        path: '/advertisement/position',
        component: () => import('@/views/ita/advertisement/position'),
        name: 'AdvertisementPosition',
        meta: { title: '版位管理', icon: 'el-icon-set-up' },
      },
    ],
  },
  {
    path: '/contract',
    component: Layout,
    redirect: '/contract',
    alwaysShow: false, // will always show the root menu
    name: 'Contract',
    meta: {
      keepAlive: true,
      title: '線上合約',
      icon: 'document',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/ita/contract/index'),
        name: 'contractIndex',
        meta: { title: '線上合約', icon: 'el-icon-document' },
      },
    ],
  },
  {
    path: '/auth',
    component: Layout,
    alwaysShow: true,
    name: 'AuthorityManagement',
    meta: {
      keepAlive: true,
      title: '權限管理',
      icon: 'el-icon-key',
    },
    children: [
      {
        path: '/auth/member/index',
        component: () => import('@/views/ita/auth/member/index'),
        name: 'ItaMemberManagement',
        meta: { title: 'ITA帳號管理', icon: 'el-icon-user' },
      },
      {
        path: '/auth/role/index',
        component: () => import('@/views/ita/auth/role/index'),
        name: 'ItaRoleManagement',
        meta: { title: 'ITA角色管理', icon: 'el-icon-lock' },
      },
      {
        path: '/auth/agencyMember/index',
        component: () => import('@/views/ita/agency/agencyMember/index'),
        name: 'AgencyMember',
        meta: { title: '帳號管理', icon: 'el-icon-view' },
      },
      {
        path: '/auth/appVersion/index',
        component: () => import('@/views/ita/auth/appVersion/index'),
        name: 'AppVersion',
        meta: { title: 'App版本', icon: 'el-icon-sunny' },
      },
      {
        path: '/auth/userLog/index',
        component: () => import('@/views/ita/auth/userLog/index'),
        name: 'UserLog',
        meta: { title: '使用者紀錄', icon: 'el-icon-document' },
      },
      {
        path: '/auth/guideRecord/index',
        component: () => import('@/views/ita/auth/guideRecord/index'),
        name: 'GuideRecord',
        meta: { title: '語音導覽紀錄', icon: 'el-icon-document' },
      },
      // {
      //   path: "/auth/newebpay/index",
      //   component: () => import("@/views/ita/auth/newebpay/index"),
      //   name: "newebpay",
      //   meta: { title: "藍新金流", icon: "el-icon-money" },
      // },
      // {
      //   path: "/auth/agencyRole/index",
      //   // component: () => import('@/views/ita/agency/agencyLeaderHunter/index'),
      //   component: () => import("@/views/error-page/999"),
      //   name: "RoleManagement",
      //   meta: {  title: "角色管理", icon: "el-icon-sunny" },
      // },
    ],
  },
  {
    path: '/system',
    component: Layout,
    alwaysShow: true,
    name: 'SystemManagement',
    meta: {
      keepAlive: true,
      title: '系統管理',
      icon: 'el-icon-setting',
    },
    children: [
      {
        path: '/system/countriesMenu/index',
        component: () => import('@/views/ita/system/countriesMenu/index'),
        name: 'CountriesMenu',
        meta: { title: '國家選單設定', icon: 'el-icon-info' },
      },
      {
        path: '/system/noticeLog/index',
        component: () => import('@/views/ita/system/noticeLog/index'),
        name: 'NoticeHistory',
        meta: { title: '推播通知歷史', icon: 'el-icon-info' },
      },
      {
        path: '/system/deployTask/index',
        component: () => import('@/views/ita/system/deployTask/index'),
        name: 'DeployTask',
        meta: { title: '更版任務', icon: 'el-icon-info' },
      },
      {
        path: '/system/aiAgent/index',
        component: () => import('@/views/ita/system/aiAgent/index'),
        name: 'AiAgent',
        meta: { title: 'AIAgent', icon: 'el-icon-info' },
      },
    ],
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true },
]

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    // mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
